import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ darkMode, setDarkMode }) => {
  const menuItems = [
    { path: '/cables-design',    label: 'Cables Design',    icon: '⟜' },
    { path: '/connectors-stock', label: 'Connectors Stock', icon: '◈' },
    { path: '/cable-stock',      label: 'Cable Stock',      icon: '≋' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-inner">

        {/* Logo */}
        <NavLink to="/" className="logo-area">
          <img
            src="/images/logo.png"
            alt="Agam Robotics"
            className="logo-img"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <div className="logo-text">
            <div className="logo-brand-row">
              <span className="logo-name">AGAM</span>
              <span className="logo-robotics">ROBOTICS</span>
            </div>
            <span className="logo-sub">internals</span>
          </div>
        </NavLink>

        {/* Nav links */}
        <div className="nav-menu">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
              <div className="nav-underline" />
            </NavLink>
          ))}
        </div>

        {/* Theme toggle */}
        <button
          className="mode-toggle"
          onClick={() => setDarkMode(!darkMode)}
          aria-label="Toggle theme"
        >
          <span className="toggle-icon">{darkMode ? '☽' : '☀'}</span>
          <span className="toggle-label">{darkMode ? 'Dark' : 'Light'}</span>
        </button>

      </div>
    </nav>
  );
};

export default Navbar;
